import { RCAppProps, RCLoadingSpinner, RcxTheme } from "@railcrew/design";
import { FC, ReactNode, useContext } from "react";
import { OnUserLoadedEvent } from "azure-integration/AuthenticatedApp";
import  { AuthConfig } from "azure-integration/authConfig";
import  {default as AuthenticatedAppGeneric } from "azure-integration/AuthenticatedApp";
import { AuthContext } from "common/AuthProvider";

export interface AuthAppProps {
  configProvider: AuthConfig;
  apiScopes?: string[];
  graphScopes?: string[];
  onAuthenticated?(): void;
  onUserLoaded?(opts: OnUserLoadedEvent): void;
  title: string;
  homeUrl?: string;
  theme?: RcxTheme;
  isLoading?: boolean;
  contentWidth?: string;
  contentStyles?: RCAppProps["contentStyles"];
  error?: {
    onRetry(): void;
    errorMessage: string;
  };
  children?: ReactNode;
}

export interface AuthenticatedAppProps {
    configProvider: AuthConfig;
    apiScopes?: string[];
    graphScopes?: string[];
    onAuthenticated?(): void;
    onUserLoaded?(e: OnUserLoadedEvent): void;
  }

const AuthApp: FC<AuthAppProps> = (props) => {
  const graphScopes = [...(props.graphScopes || [])].map((x) => x.toLowerCase());
  const { setUser, setUserRoles } = useContext(AuthContext);

  if (!graphScopes.includes("user.read")) {
    graphScopes.push("user.read");
  }
  const onUserLoaded = (opts: OnUserLoadedEvent) => {
    props.onUserLoaded && props.onUserLoaded(opts);
    !opts.error && setUser(opts.user);
     setUserRoles();
  };
  const appProps: AuthenticatedAppProps = { ...props, graphScopes, onUserLoaded};
  return (
    <AuthenticatedAppGeneric {...appProps}>
      {props.isLoading ? <RCLoadingSpinner/> : <>{props.children}</>}
    </AuthenticatedAppGeneric>
  );
};

export default AuthApp;
